import { FormGroup, Icon } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { TipiStore } from "../../stores/legislacao/TipiStore";
import { AppStore } from "../../stores/AppStore";
import { Pager } from "../utils/Pager";
import { ITipi } from "../../model";
import { TipiDialogEdit } from "./TipiDialogEdit";


const InputMask = require("react-input-mask");
var debounce = require('lodash.debounce');

interface TipiProps {
}

interface TipiState {
}

@observer
export class TipiPage extends React.Component<TipiProps, TipiState> {

  obs = observable({
    page: 1 as number,
    fetchOptions: {} as any,
    edit_tipi: null as ITipi,
    ncm: "" as string
  })

  constructor(props) {
    super(props);
    this.state = { handlePageChange: props.handlePageChange };

    this.obs.fetchOptions = debounce(this.handleBusca.bind(this), 800);

  }

  async componentDidMount() {

    AppStore.setTitle("Tabela Tipi");

    await TipiStore.load(1);

  }

  /**
  * Atualiza a página atual e carrega os dados TIPI correspondentes.
  *
  * A função:
  * - Chama `TipiStore.load(page)` para carregar os registros da nova página.
  * - Atualiza o valor de `this.obs.page` com o número da página recebida.
  *
  * @async
  * @param {number} page Número da nova página a ser carregada.
  *
  * @returns {Promise<void>} Promise resolvida após a atualização da página e carregamento dos dados.
  */

  handlePageChange = async (page: number) => {
    TipiStore.load(page);
    this.obs.page = page;
  };

  /**
  * Realiza a busca de registros TIPI com base no NCM informado.
  *
  * A função:
  * - Extrai todos os números da string `this.obs.ncm` utilizando uma expressão regular (`\d+`).
  * - Se números forem encontrados:
  *   - Concatena-os em uma única string.
  *   - Chama `TipiStore.busca` passando o NCM processado e a página atual (`this.obs.page`).
  * - Caso contrário:
  *   - Chama `TipiStore.load` apenas com a página atual para carregar todos os registros.
  *
  * @async
  * @returns {Promise<void>} Promise resolvida após a execução da busca ou carregamento dos TIPIs.
  */

  handleBusca = async () => {

    const numbers = this.obs.ncm.match(/\d+/g);

    if (numbers != null) {

      await TipiStore.busca(numbers.join(''), this.obs.page);

    } else {

      await TipiStore.load(this.obs.page);

    }

  };

  /**
  * Atualiza o valor do NCM com o filtro fornecido e recarrega as opções disponíveis.
  *
  * A função:
  * - Atribui o valor de `filter` ao campo observável `this.obs.ncm`.
  * - Em seguida, chama o método `this.obs.fetchOptions()` para buscar novas opções relacionadas ao NCM informado.
  *
  * @async
  * @param {string} filter Valor a ser utilizado como filtro de NCM.
  *
  * @returns {Promise<void>} Promise resolvida após a atualização e carregamento das opções.
  */

  ncmBusca = async (filter) => {

    this.obs.ncm = filter

    this.obs.fetchOptions()

  };

  /**
  * Finaliza a edição de um registro TIPI e recarrega a listagem de acordo com o NCM atual.
  *
  * A função:
  * - Reseta o campo `this.obs.edit_tipi` para `null`, encerrando o estado de edição.
  * - Extrai todos os números da string `this.obs.ncm` usando expressão regular (`\d+`).
  *   - Caso existam números:
  *     - Concatena-os em uma string única.
  *     - Chama `TipiStore.busca` passando o NCM processado e a página atual (`this.obs.page`).
  *   - Caso contrário:
  *     - Chama `TipiStore.load` apenas com a página atual.
  *
  * @async
  * @returns {Promise<void>} Promise resolvida após a execução da busca ou carregamento de TIPIs.
  */

  handleEditClose = async () => {
    this.obs.edit_tipi = null;

    const numbers = this.obs.ncm.match(/\d+/g);

    if (numbers != null) {

      await TipiStore.busca(numbers.join(''), this.obs.page);

    } else {

      await TipiStore.load(this.obs.page);

    }

  };

  /**
  * Define o registro TIPI que está sendo editado.
  *
  * A função:
  * - Atribui o objeto `tipi` recebido ao campo observável `this.obs.edit_tipi`.
  * - Isso permite que o formulário ou componente associado entre no modo de edição com os dados do TIPI selecionado.
  *
  * @param {Object} tipi Objeto TIPI que será editado.
  *
  * @returns {void}
  */


  handleEditTipi = (tipi) => {

    this.obs.edit_tipi = tipi;

  };

  render() {

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    const formattValidade = (cell, row) => {

      return (
        <>
          {
            row.data_inicio  ?
            <span>{moment(row.data_inicio).format("DD/MM/YYYY")}</span>
              :
            <span>Sempre</span>
          }
          <Icon icon="arrow-right" style={{ margin: "0 5px" }} />
          {
            row.data_fim ?
              <span>{moment(row.data_fim).format("DD/MM/YYYY")}</span>
              :
              <span>Sempre</span>
          }
        </>
      )
    };

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => this.handleEditTipi(row)}
          >
            <img src="/images/edit.png" width={25} />
          </MDBBtn>
        </>
      );
    }

    return (
      <>
        <MDBRow xl="12" lg="12" md="12" sm="12">
          <MDBCol xl="2" lg="2" md="2" sm="2">
            <FormGroup label="NCM">
              <InputMask
                mask="9999.99.99"
                className="form-control"
                value = {this.obs.ncm}
                onChange={(e) => this.ncmBusca(e.target.value)}
              />
            </FormGroup>
          </MDBCol>

        </MDBRow>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={TipiStore.obs.tipis}
          >
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="ncm" width="10%">
              NCM
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={formattValidade} width="10%">
              Validade
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="descricao"
              width="10%"
            >
              Descrição
            </TableHeaderColumn>

            {user_admin &&
            <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="1%">Ações</TableHeaderColumn>
            }

          </BootstrapTable>

        {this.obs.edit_tipi && <TipiDialogEdit tipi={this.obs.edit_tipi} onClose={this.handleEditClose} />}
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.page}
            totalCount={TipiStore.obs.total}
            pageSize={15}
            onPageChange={this.handlePageChange}
          />
        </div>
      </>
    );
  }
}
